import Button from '@material-ui/core/Button';
import KioskLog from 'models/KioskLog';
import PropTypes from 'prop-types';
import React from 'react';
import { actions as categoriesActions } from 'redux/domain/Categories';
import { bindActionCreators } from 'redux';
import { cancelRequest, getCancelTokenSource } from 'api/Helpers';
import { connect } from 'react-redux';
import { getCategoryChildren, getCategoryParentId } from 'shared/utils/categoryHelpers';
import { Link } from 'react-router-dom';
import { withTheme } from '@material-ui/core/styles';
import styles from '../styles.css';
import withRouter from '../../../shared/utils/WithRouter';

class ParentCategoryBar extends React.Component {
	/**
	 * This is run for each child of the parent category.
	 * A button is rendered with a link to that category.
	 * @param {object} category
	 */
	static renderButton(currentCat, category, theme) {
		// if the category for the button being created
		// matches the category of the current page
		// the background color will be different
		// need to covert to a string for the compare to work
		const categoryString = category.categoryId.toString();
		return (
			<Link
				to={`/category/${category.categoryId}`}
				className={styles['category-button']}
				key={category.categoryId}
				style={categoryString === currentCat ? { backgroundColor: theme.palette.grey[900] } : null}
			>
				<Button
					style={{
						display: 'inline-block',
						paddingTop: '10px',
						minWidth: '100%',
					}}
					TouchRippleProps={{ style: { color: theme.palette.common.white } }}
				>
					<div style={{ color: theme.palette.common.white }}>{category.name}</div>
				</Button>
			</Link>
		);
	}

	constructor() {
		super();
		this.cancelSource = getCancelTokenSource();
	}

	componentDidMount() {
		this.getAllCategoriesAsync();
	}

	componentWillUpdate(nextProps) {
		if (nextProps.fetchError) {
			const errorLocation = nextProps.allCategories.get(Number(nextProps.id));
			const log = new KioskLog(
				new Error('Fetch Error in ParentCategoryBar'),
				`Error fetching "${errorLocation}" category - Id: ${nextProps.id}`,
			);
			log.postMessage();
			this.props.router.navigate('/errorPage', { 
				state: {
					text: `We couldn't find the "${errorLocation.name}" category.`,
					nextLine: `(Category id: ${nextProps.id})`,
			} });
		}
	}

	componentWillUnmount() {
		// if a request is in progress stop it.
		cancelRequest(this.cancelSource);
	}

	/**
	 * Get a a list of all available categories.
	 */
	getAllCategoriesAsync() {
		try {
			this.props.getAllCategories(this.cancelSource.token);
		} catch (error) {
			const log = new KioskLog(
				error,
				'Error file location: features/Categories/components/ParentCategoryBar',
			);
			log.postMessage();
		}
	}

	/**
	 * This renders the category bar on the top of the screen.
	 *
	 * If there is an id of 'search' passed in, then the parentId
	 * gets set to 0 and renders all top level categories.
	 */
	renderParentCategories() {
		const { theme } = this.props;
		const { allCategories, id } = this.props;
		const parentId = id === 'search' ? 0 : getCategoryParentId(id, allCategories);
		const catChildren = getCategoryChildren(parentId, allCategories);
		return catChildren.length === 0 ? null : (
			<div
				className={styles['parent-category-bar']}
				style={{
					backgroundColor: theme.palette.grey[800],
				}}
			>
				<div className={styles['hide-scroll']}>
					<div className={styles['hide-scroll-child']}>
						{catChildren.map(category => ParentCategoryBar.renderButton(id, category, theme))}
					</div>
				</div>
			</div>
		);
	}

	render() {
		return this.renderParentCategories();
	}
}

ParentCategoryBar.propTypes = {
	allCategories: PropTypes.objectOf(PropTypes.object).isRequired,
	getAllCategories: PropTypes.func.isRequired,
	id: PropTypes.string,
	theme: PropTypes.instanceOf(Object).isRequired,
};

ParentCategoryBar.defaultProps = { id: null };

const mapStateToProps = state => {
	const allCategories = state.categories.get('allCategories');
	const isFetching = state.categories.get('isFetching');
	const fetchError = state.categories.get('fetchError');
	return {
		allCategories,
		isFetching,
		fetchError,
	};
};

const mapDispatchToProps = dispatch => bindActionCreators(categoriesActions, dispatch);

// for testing purposes
export { ParentCategoryBar as ParentCategoryBarClass };

// connect returns a function that accepts a component
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(ParentCategoryBar)));
